import axios from 'axios';

const createGroup = params => axios.post('groups', params);

export { createGroup };
